import React, { useRef, useState } from 'react'
import { ReactComponent as IconDeleteProduct } from '../../assets/images/icons/icon-delete.svg'
import { Link, useNavigate, useParams } from 'react-router-dom'
import { designerManagement } from '../../config/routingConsts'
import requestApi from '../../utils/request'
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import VendorProductTab from '../../components/TabsForVendors/VendorProductTab'
import VendorOrderTab from '../../components/TabsForVendors/VendorOrderTab'
import DeleteModal from '../../components/DeleteModal/DeleteModal'
import VendorReviewTab from '../../components/TabsForVendors/VendorReviewTab/VendorReviewTab'
import DummyUserImage from '../../assets/images/user-profile.png'
import FeesModal from '../../components/FeesModal/FeesModal'

//#region  API Call for view Vendor Data
const vendorViewDetail = async (sellerId) => {
    return await requestApi
        .post(`vendor/view`, { sellerId }, { headers: true })
        .then((res) => {
            return res.data
        })
}
//#endregion

const DesignerView = () => {
    const [editbtn, seteditbtn] = useState(false)

    const navigate = useNavigate()
    const [activeTab, setActiveTab] = useState('products')
    const { sellerId } = useParams()
    const [isDeleteModal, setIsDeleteModal] = useState(false)
    const [deleteId, setDelteId] = useState('')
    const queryClient = useQueryClient()
    const EditDataRef = useRef(null)

    const { data, isLoading } = useQuery({
        queryKey: ['vendor-view'],
        queryFn: () => vendorViewDetail(sellerId),
        enabled: !!sellerId,
        onSuccess: (data) => {
            //     reset({
            //         size:data?.data?.name
            //     })
        },
        onError: (error) => {
            console.log(error.message)
        }
    })

    const handleTabClick = (tabIndex) => {
        setActiveTab(tabIndex)
    }

    //#region  Delete Designer(Seller) by ID
    const handleDeleteModal = (id) => {
        setIsDeleteModal(true)
        setDelteId(id)
    }

    function handleDelete(sellerId) {
        mutationDelete.mutate(sellerId)
        setIsDeleteModal(false)
        navigate(designerManagement)
    }

    async function deleteSellerById(sellerId) {
        return await requestApi.post(`vendor/delete`, {
            sellerId
        })
    }

    const mutationDelete = useMutation(deleteSellerById, {
        onSuccess: ({ data }) => {
            queryClient.invalidateQueries('designerList')
            setIsDeleteModal(false)
            EditDataRef.current = null
        },
        onError: () => {
            EditDataRef.current = null
        }
    })
    //#endregion
   
    const [getFees, setFees] = useState('')
    const handleEditBtn = (fees) => {
        seteditbtn(true)
        setFees(fees)
    }

    return (
        <>
            <div className="view-product-details view-buyer-details">
                <ul className="site-breadcrumb">
                    <li>
                        <Link to={designerManagement}>Designer Management</Link>
                    </li>
                    <li>Designer Detail</li>
                </ul>
                <div className="admin-card">
                    <div className="head">
                        <h2>Designer Detail</h2>
                        <div
                            className="delete-btn"
                            onClick={() => handleDeleteModal(sellerId)}
                        >
                            <IconDeleteProduct />
                        </div>
                    </div>
                </div>
                <div className="admin-card product-details-card buyer-profile-detail">
                    <div className="image-wrapper">
                        {data?.data?.profilePic ? (
                            <img src={data?.data?.profilePic} alt="Designer" />
                        ) : (
                            <img src={DummyUserImage} alt="Designer" />
                        )}
                        <p>Designer Name</p>
                        <h6>
                            {data?.data?.fullName ? data?.data?.fullName : '-'}
                        </h6>
                    </div>
                    <ul className="product-details-list justify-content-start">
                        <li>
                            <span>Designer ID</span>#
                            {data?.data?.sellerUniqueId
                                ? data?.data?.sellerUniqueId
                                : '-'}
                        </li>
                        <li>
                            <span>Email address</span>
                            {data?.data?.email ? data?.data?.email : '-'}
                        </li>
                        <li>
                            <span>Total products</span>
                            {data?.data?.totalProduct
                                ? data?.data?.totalProduct
                                : '0'}
                        </li>
                        <li>
                            <span>Total orders</span>
                            {data?.data?.totalOrder
                                ? data?.data?.totalOrder
                                : '0'}
                        </li>
                        <li>
                            <span>GST No.</span>
                            {data?.data?.gst ? data?.data?.gst : '-'}
                        </li>
                        <li>
                            <span>
                                Service Fee %{' '}
                                <button 
                                className="edit-btn"
                                    onClick={() =>
                                        handleEditBtn(data?.data?.servicefee)
                                    }
                                >
                                    Edit
                                </button>
                            </span>
                            {data?.data?.servicefee
                                ? data?.data?.servicefee
                                : '-'}
                        </li>
                    </ul>
                </div>
            </div>

            <div className="tabbing-wrapper">
                <div className="admin-card tab-menu" id="nav-tab">
                    <ul>
                        <li className="tab-link">
                            <a
                                className={
                                    activeTab === 'products' ? 'active' : ''
                                }
                                onClick={() => handleTabClick('products')}
                            >
                                Products
                            </a>
                        </li>
                        <li className="tab-link">
                            <a
                                className={
                                    activeTab === 'orders' ? 'active' : ''
                                }
                                onClick={() => handleTabClick('orders')}
                            >
                                Orders
                            </a>
                        </li>
                        <li className="tab-link">
                            <a
                                className={
                                    activeTab === 'reviews' ? 'active' : ''
                                }
                                onClick={() => handleTabClick('reviews')}
                            >
                                Reviews
                            </a>
                        </li>
                    </ul>
                </div>
                <div className="tab-content p-0" id="nav-tabContent">
                    <div
                        id="products"
                        className={`tab-pane ${
                            activeTab === 'products' ? 'active' : ''
                        }`}
                    >
                        <VendorProductTab />
                    </div>
                    <div
                        id="orders"
                        className={`tab-pane ${
                            activeTab === 'orders' ? 'active' : ''
                        }`}
                    >
                        <VendorOrderTab />
                    </div>
                    <div
                        id="reviews"
                        className={`tab-pane ${
                            activeTab === 'reviews' ? 'active' : ''
                        }`}
                    >
                        <VendorReviewTab />
                    </div>
                </div>
            </div>
            <DeleteModal
                message={
                    <>
                        Are you sure you want to <br /> Delete this designer ?
                    </>
                }
                setIsDeleteModal={setIsDeleteModal}
                isDeleteModal={isDeleteModal}
                handleDelete={() => handleDelete(deleteId)}
            />
            {editbtn && (
                <FeesModal
                    editbtn={editbtn}
                    seteditbtn={seteditbtn}
                    getFees={getFees}
                    setFees={setFees}
                    sellerId={sellerId}
                />
            )}
        </>
    )
}

export default DesignerView
